import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { Language } from '@ilteducation/content-ref-data-types';
import type { AudioFragmentV1, NewAudioFragmentV1 } from '@ilteducation/content-registry-types';
import { BaseState } from '@ilteducation/content-registry-types/enums/content-enums';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import { getAllRefData } from '@/data-provider/refDataProvider';
import useMediaFormFeature from '@/comp/use-media-form-feature';
import ChipField from '@/components/base/ChipField.vue';

type Props = {
  id?: string;
  title: string;
  item?: NewAudioFragmentV1 | AudioFragmentV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: NewAudioFragmentV1 | AudioFragmentV1;
}


const availableLanguages = ref<Language[]>([]);

const getAvailableLanguages = () => {
  getAllRefData('languages').then((languages) => {
    availableLanguages.value = languages;
  });
};
getAvailableLanguages();

const {
  uploadMedia,
  saveButtonAvailable,
  isCloneMode,
  publishButtonAvailable,
  toggleStateInProgress,
  toggleMediaState,
} = useMediaFormFeature(props.item);
const notEmptyRule = ref([(val: any) => (val || '').length > 0 || 'This field is required']);
const def = { type: 'AudioFragmentV1', realm: 'all' };

return { __sfc: true,props, availableLanguages, getAvailableLanguages, uploadMedia, saveButtonAvailable, isCloneMode, publishButtonAvailable, toggleStateInProgress, toggleMediaState, notEmptyRule, def, BaseState, DisableableButton, ChipField }
}

})